import axiosBackEnd from "../../config/axios/axios-back-end";
import * as actionTypes from "./actionTypes";
import { apiStart, apiComplete, apiFail } from "./api";
import { message } from "antd";

export const notificationSetHmg = (hmg) => {
  return {
    type: actionTypes.SET_NOTIF_HMG_LIST,
    value: hmg,
  };
};

export const notificationCreateSuccess = (msg) => {
  return {
    type: actionTypes.SET_NOTIF_COMPLETE_SUCCESS,
    value: msg.data,
  };
};

export const notificationCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/setNotifications", data, {
        headers: headers,
      });
      dispatch(notificationCreateSuccess(response.data));
      message.success(response.data.message);
      dispatch(apiComplete());
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};
